




















































































































import DateFieldCustom from '@/components/base/DateFieldCustom.vue';
import { mdiMagnify, mdiFilter } from '@mdi/js';
import { Component, Vue } from 'vue-property-decorator';
import { getUserStatementTypes } from '@/api/statements';
import { StatementsModule } from '@/store/modules/statements';
import { getUserStatementStatuses } from '@/api/statements';
import { debounce } from 'debounce';

@Component({
  components: { DateFieldCustom },
  validations() {
    return {
      form: {
        dateFilter: {},
      },
    };
  },
  data: () => ({
    mdiMagnify,
    mdiFilter,
    menu: false,
    showFilters: true,
    form: {
      typeStatements: [
        'Все',
        'Ожидает подтверждения оплаты',
        'Отложено',
        'Принято',
      ],
      dateFilter: '',
      numberFilter: '',
    },
  }),
})
export default class Filters extends Vue {
  private statementsTypes: any[] = [];
  private typeFilter: string = '';
  private codeFilter: string = '';
  private dateFilter: string = '';
  private statusFilter: any = [];
  private statusListForUser: any[] = [];
  textFieldInputHandler: Function | null = null;

  async mounted() {
    await this.getData();
  }

  created() {
    this.textFieldInputHandler = debounce(() => {
      this.onChangeFilter();
    }, 500);
  }

  sortFilterTitle(filterValues: any, reverse?: boolean) {
    const result = filterValues.sort(function (a: any, b: any) {
      if (a.title < b.title) {
        return -1;
      }
      if (a.title > b.title) {
        return 1;
      }
      return 0;
    });

    return reverse ? result.reverse() : result;
  }

  async getData() {
    const data = await getUserStatementTypes();
    this.statementsTypes = [...data];
    this.statusListForUser = await getUserStatementStatuses();

    // преобразуем данные (сортируем, добавляем элементы)
    this.statementsTypes.push({ code: 'NOT_SELECT', title: 'Не выбран' });
    this.statementsTypes = this.sortFilterTitle(this.statementsTypes);
    this.statusListForUser = this.sortFilterTitle(this.statusListForUser);

    this.prefillFilter();
  }

  get isSelectedAllStatusFilter() {
    return this.statusFilter.length === this.statusListForUser.length;
  }

  get isSelectedSomeStatusFilter() {
    return this.statusFilter.length > 0 && !this.isSelectedAllStatusFilter;
  }

  get icon() {
    if (this.isSelectedAllStatusFilter) return 'mdi-close-box';
    if (this.isSelectedSomeStatusFilter) return 'mdi-minus-box';
    return 'mdi-checkbox-blank-outline';
  }

  async toggle() {
    this.$nextTick(() => {
      if (this.isSelectedAllStatusFilter) {
        this.statusFilter = [];
      } else {
        this.statusFilter = this.statusListForUser.map(
          (item: any) => item.code
        );
      }
      this.onChangeFilter();
    });
  }

  async changeFilter() {
    const filter = {
      extId: this.codeFilter,
      statementType: this.typeFilter,
      createDate: this.dateFilter,
      status: [...this.statusFilter],
    };

    await StatementsModule.filter({ ...filter });
    StatementsModule.setFilterLocalStorage({ ...filter });
  }

  async onChangeFilter() {
    await this.changeFilter();
    this.$emit('changeFilter');
  }

  async resetFilter() {
    this.codeFilter = '';
    this.typeFilter = '';
    this.dateFilter = '';
    this.statusFilter = '';
    await this.changeFilter();
  }

  prefillFilter() {
    const filter = StatementsModule.filters;
    this.codeFilter = filter && filter.extId ? filter.extId : '';
    this.typeFilter =
      filter && filter.statementType ? filter.statementType : '';
    this.dateFilter = filter && filter.createDate ? filter.createDate : '';
    this.statusFilter = filter && filter.status ? [...filter.status] : '';
  }
}
